import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from "@angular/core";

import { WoundCare, WoundCarePicture, WoundCareStatus } from "../../../shared/types";

@Component({
	selector: "wound-care-item",
	templateUrl: "wound-care-item.component.html",
	styleUrls: ["wound-care-item.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class WoundCareItemComponent {
	public woundCarePictures: WoundCarePicture[] = [];
	// @ts-expect-error TS2564
	private _woundCare: WoundCare;

	@Output() pictures = new EventEmitter();
	@Output() details = new EventEmitter();
	@Input() set woundCare(value: WoundCare) {
		this._woundCare = value;

		this.woundCarePictures = value.pictures;
	}

	get woundCare() {
		return this._woundCare;
	}

	isHealed() {
		return this._woundCare.status === WoundCareStatus.HEALED;
	}
}
